// Reusable ShimmerBar component (can be moved to a shared location later)
const ShimmerBar = ({ className }: { className?: string }) => (
  <div className={`bg-muted dark:bg-muted-foreground/20 animate-pulse rounded ${className}`} />
);

const SpendingRowSkeleton = () => (
  <div className="flex justify-between items-center space-x-2 h-[36px]"> {/* Match height */} 
    <div className="relative flex-1 min-w-0">
      <ShimmerBar className="relative w-2/3 h-6" />
    </div>
    <ShimmerBar className="w-12 h-6" /> 
  </div>
);

function SpendingSummarySkeleton() {
  return (
    <>
        <SpendingRowSkeleton />
        <SpendingRowSkeleton />
        <SpendingRowSkeleton />
        <SpendingRowSkeleton />
        <SpendingRowSkeleton />
    </>
  );
}

export default SpendingSummarySkeleton; 
